<!-- 生成组织证书弹窗 -->
<template>
  <el-dialog
    class="gen-org-cert-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
    top="25vh"
  >
    <el-form
      ref="editForm"
      :model="editForm"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
    >
      <el-form-item label="组织名称" prop="OrgName">
        <el-input v-model="editForm.OrgName"></el-input>
      </el-form-item>
      <el-form-item label="组织ID" prop="OrgId">
        <el-input v-model="editForm.OrgId"></el-input>
      </el-form-item>

      <el-form-item label="加密算法" prop="Algorithm">
        <el-select v-model="editForm.Algorithm" placeholder="请选择" clearable class="auto-width">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleOk()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'GenOrgCert',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 85
  },
  data() {
    return {
      disabled: false,
      title: '生成组织证书',
      dialogVisible: false,
      editForm: {
        Algorithm: '',
        OrgId: '',
        OrgName: '',
        CertType: 0
      },
      editRules: {
        Algorithm: [{ required: true, message: '请选择算法', trigger: 'blur' }],
        OrgName: [{ required: true, message: '请填写组织名称', trigger: 'blur' }],
        OrgId: [{ required: true, message: '请填写组织ID', trigger: 'blur' }]
      },
      options: [
        { label: '国密', value: 0 },
        { label: 'ECDSA', value: 1 }
        // { label: 'IBC', value: 2 }
      ],
      adaptationVars: {
        formLabelWidth: 85
      }
    }
  },
  methods: {
    handleCancel() {
      this.editForm = {
        Algorithm: '',
        OrgId: '',
        OrgName: '',
        CertType: 0
      }
      this.disabled = false
      this.$refs.editForm.clearValidate()
      this.dialogVisible = false
    },
    handleOpen() {
      this.dialogVisible = true
    },
    handleOk() {
      this.disabled = true
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$apis.certificate
            .genCert(this.editForm)
            .then(res => {
              if (res?.errors == null) {
                this.$message.success('生成组织证书成功！')
                this.$emit('update:list')
                this.handleCancel()
              }
            })
            .catch(err => {
              this.$message.warning('生成证书失败，err:' + err.message)
              return
            })
        } else {
          this.$message.warning('请填写内容')
          this.disabled = false
          return
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.gen-org-cert-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
